import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            marginTop: theme.spacing(2),
            height: 600,
        },
        containerRoute: {
            width: '20%',
            marginRight: 12,
        },
        containerMap: {
            width: '80%',
        },
        wrapper: {
            paddingTop: theme.spacing(3),
        },
        tab: {
            textDecoration: 'none',
            color: theme.typography.body1.color,
            fontSize: theme.typography.subtitle1.fontSize,
            padding: '0 10px',
        },
        activeTab: {
            borderBottom: `3px solid ${theme.palette.primary[400]}`,
        },
        // shared styles
        item: {
            display: 'flex',
        },
        containerIcon: {
            paddingRight: theme.spacing(1.5),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        verticalLine: {
            height: 12,
            width: 3,
            margin: '2px 0',
            background: theme.palette.primary[200],
        },
        label: {
            paddingTop: theme.spacing(0.7),
        },
        labelContainer: {
            paddingTop: '0 !important',
        },
        locationInput: {
            width: '100%',
            paddingRight: theme.spacing(1.5),
        },
    }
})

export default useStyles
